import React, { MouseEventHandler } from 'react';

import CtaButton from '../cta-button/cta-button';
import styles from '../../../utils/styles';
import './load-more-button.scss';
import { ComponentSize, COMPONENT_SIZE_MEDIUM, COMPONENT_SIZE_LARGE } from '../../../typings/design-tokens';

export const LOAD_MORE_SIZE_MEDIUM = COMPONENT_SIZE_MEDIUM;
export const LOAD_MORE_SIZE_LARGE = COMPONENT_SIZE_LARGE;

export interface ILoadMoreButton {
  className?: string;
  onClick?: MouseEventHandler | undefined;
  size?: ComponentSize;
}

const sizeTextMap = {
  [COMPONENT_SIZE_MEDIUM]: 'CARICA ALTRI',
  [COMPONENT_SIZE_LARGE]: 'CARICA ALTRI VIDEO',
};

const LoadMoreButton: React.FC<ILoadMoreButton> = ({
  className: outerClassName,
  onClick,
  size = COMPONENT_SIZE_MEDIUM,
}) => {
  const className = [outerClassName, styles(`load-more-button--${size}`)].join(' ');

  return (
    <CtaButton onClick={onClick} iconPosition="right" className={className}>
      {sizeTextMap[size]}
    </CtaButton>
  );
};

export default LoadMoreButton;
